import { useState } from 'react';

import { Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import MSHModal from './mshModal/MSHModal';
import StepItem from '../stepItem/StepItem';

const MajorShareholderCheckAction = ({
    status
}: {
    status: TFundingRequirementsSteps['0']['status'];
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <StepItem
                title={
                    <FormattedMessage
                        id="_.funding_requirements.major_shareholder_check_title"
                        defaultMessage="Add directors and shareholders"
                    />
                }
                caption={
                    <FormattedMessage
                        id="_.funding_requirements.major_shareholder_check_caption"
                        defaultMessage="Add details of all directors and major shareholders."
                    />
                }
                action={
                    <FundingStepActionButton
                        actionMessage={
                            <FormattedMessage
                                id="_.funding_requirements.major_shareholders_check_action"
                                defaultMessage="Add details"
                            />
                        }
                        pendingMessage={
                            <FormattedMessage
                                id="_.funding_requirements.major_shareholders_check_action_pending"
                                defaultMessage="Pending"
                            />
                        }
                        status={status}
                        handleFundingStepAction={() => setIsModalOpen(true)}
                        stepName="Major shareholder check"
                    />
                }
            />
            <Modal isOpen={isModalOpen} onClose={handleModalClose} closeIcon>
                <MSHModal onClose={handleModalClose} />
            </Modal>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default MajorShareholderCheckAction;
